import React, { useState, useEffect } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ArrowLeft, Save } from "react-feather";
import ToastNotification from "Components/UI/ToastNotification";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import Error404 from "MainPages/ErrorPages/error404";
import { all_routes } from "Router/all_routes";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useUpdateUserGroupMutation } from "AppQuries/user/user-group";
import { userMasterValidation } from "core/Operations/ValidationSchema/userValidationSchema";
import UserMasterForm from "Components/Form/UserMasterForm";
import { getCurrentFormattedDate } from "core/Operations/currentDateTime";
import {
  useGetUserMasterByIdQuery,
  useUpdateUserMasterMutation,
} from "AppQuries/user/user-master";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import { toast } from "core/Operations/toast";
import UserMasterDetails from "./Details/UserMasterDetails";
import UserLoginHistory from "./Details/UserLoginHistory";
const ViewUserMaster = () => {
  const userData = useSelector(loggedInUser);
  const { code } = useParams();
  const {
    data: userMasterData,
    isLoading,
    isError: isFetchingError,
    error: fetchingError,
  } = useGetUserMasterByIdQuery({
    companyCode: userData?.companyCode,
    code: code,
  });

  const navigate = useNavigate();

  //   if (isError) return <Error404 error={error} />;
  if (isFetchingError) return <Error404 error={fetchingError} />;
  if (isLoading) return <LoadingSpinner />;
  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>View User Master</h4>
                {/* <h6>Edit User Master </h6> */}
              </div>
            </div>
            <div className="page-btn">
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="add-new-tooltip">Back</Tooltip>}
              >
                <Link
                  to={`${all_routes.user_master}${all_routes.user_master_list}`}
                  className="btn btn-secondary"
                >
                  {/* <ArrowLeft className="me-2" /> */}
                  Back
                </Link>
              </OverlayTrigger>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card border-0">
                {/* <div className="card-header">
                  <h4 className="card-title">Update User Master</h4>
                </div> */}
                <div className="card-body">
                  <div className="row">
                    <div className="card border-0">
                      <div className="card-header">
                        {/* <ul className="nav nav-tabs nav-tabs-bottom nav-justified"> */}
                        <ul className="nav nav-tabs nav-tabs-solid nav-justified mb-3">
                          <li className="nav-item">
                            <Link
                              className="nav-link active"
                              to="#user-master-details"
                              data-bs-toggle="tab"
                            >
                              User Details
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              className="nav-link"
                              to="#login-history"
                              data-bs-toggle="tab"
                            >
                              User Login History
                            </Link>
                          </li>
                        </ul>
                      </div>
                      <div className="card-body">
                        {!isLoading && userMasterData && (
                          <div className="tab-content ">
                            <div
                              className="tab-pane show active"
                              id="user-master-details"
                            >
                              <UserMasterDetails
                                userMasterData={userMasterData}
                              />
                            </div>
                            <div className="tab-pane" id="login-history">
                              <UserLoginHistory
                                userId={code}
                                userData={userData}
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewUserMaster;
